import { computed, inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvConfigService } from '../../env-config/env-config.service';
import { Observable } from 'rxjs';
import { AuthorizeResponse } from '../api-auth/api-auth.service';

export interface Person {
    organization_id: number;
    prefix: string;
    first_name: string;
    middle_name: string;
    last_name: string;
    suffix: string;
    gender: string | null;
    birth_year: number | null;
    user_id: number;
    email: string;
    id: number;
    created_at: string;
    updated_at: string;
}

export interface PasswordChange {
    password: string;
    password_confirm: string;
}

export interface UpdatedCurrentPerson extends AuthorizeResponse {
    person: Person;
}

@Injectable({
    providedIn: 'root',
})
export class PersonsService {
    private http = inject(HttpClient);
    private config = inject(EnvConfigService);

    readonly apiUrl = computed(() => this.config.config().api.studyManager);

    fetchCurrentPerson(): Observable<Person> {
        return this.http.get<Person>(`${this.apiUrl()}/api/v1/persons/current/`);
    }

    updateCurrentPassword(body: PasswordChange): Observable<UpdatedCurrentPerson> {
        return this.http.put<UpdatedCurrentPerson>(`${this.apiUrl()}/api/v1/persons/current/`, body);
    }
}   